import { useState } from 'react';
import { Eye } from 'lucide-react';
import { fullCurrency } from '../../utils/formatCurrency.js';
import DocumentModal from '../common/DocumentModal.js';

const CompanyPaidLines = ({ row, align = 'left' }) => {
  const [receiptOpen, setReceiptOpen] = useState(false);
  const lines = Array.isArray(row?.lines) ? row.lines : [];
  const alignClass = align === 'right' ? 'items-end text-right' : 'items-start text-left';
  return (
    <div className={`flex flex-col gap-1 ${alignClass}`}>
      <p className="font-semibold text-emerald-800 tabular-nums">{fullCurrency(row?.amount)}</p>
      {lines.length ? (
        <div className="space-y-0.5">
          {lines.map((line, index) => (
            <p key={`${row?.expense_id || 'pay'}-${line.ml_sheet_id || index}`} className="text-[11px] text-gray-600 leading-tight">
              <span className="font-mono">{line.ml_sheet_id || 'Record'}</span>
              {line.location ? ` · ${line.location}` : ''}
              <span className="tabular-nums"> · {fullCurrency(line.amount)}</span>
            </p>
          ))}
        </div>
      ) : null}
      {row?.attachment_url ? (
        <button
          type="button"
          onClick={() => setReceiptOpen(true)}
          className="inline-flex items-center justify-center w-7 h-7 rounded-lg border border-blue-200 text-blue-700 hover:bg-blue-50"
          title="View receipt"
          aria-label="View receipt"
        >
          <Eye className="w-4 h-4" />
        </button>
      ) : null}
      {receiptOpen && row?.attachment_url ? (
        <DocumentModal
          isOpen={receiptOpen}
          onClose={() => setReceiptOpen(false)}
          documentUrl={row.attachment_url}
          documentType="image"
          title="Payment receipt"
          zIndexClass="z-[90]"
        />
      ) : null}
    </div>
  );
};

export default CompanyPaidLines;
